import axios from 'axios';
import authHeader from './auth.header';
import {handleRequestError} from "../errorHandler";
import {APIResponse, Trade} from '../types/APITypes'

const TRADE_SERVICE_URL = '/api/trade';
const ctype = {'Content-Type': 'application/json'}

class TradeService {
    async getTrades() {
        try {
            const response = await axios.get(TRADE_SERVICE_URL,
                {
                    headers: {...authHeader(), ...ctype}
                });
            return response.data
        } catch (error) {
            handleRequestError(error);
        }
    }

    async getHistoricalTrades(page: number, size: number) {
        try {
            const response = await axios.get(`${TRADE_SERVICE_URL}/historical`, {
                headers: { ...authHeader(), ...ctype },
                params: { page, size }
            });
            let resp: APIResponse = response.data as unknown as APIResponse;
            return {
                result: resp.result as unknown as Trade[] || [],
                totalPages: resp.totalPages ?? 1,
            };
        } catch (error) {
            handleRequestError(error);
            return { result: [], totalPages: 1 };
        }
    }


    async postNewTrades(data: Array<Trade>) : Promise<APIResponse> {
        try {
            let response = await axios.post(TRADE_SERVICE_URL, data,
                {
                    headers: {...authHeader(), ...ctype}
                });
            return response.data as unknown as APIResponse;
        } catch (error) {
            console.error("Error occurred:", error);
            throw error;
        }
    }

    async getTradeStatistics() {
        try {
            const response = await axios.get(`${TRADE_SERVICE_URL}/statistics`,
                {
                    headers: {...authHeader(), ...ctype},
                });
            return response.data;
        } catch (error) {
            handleRequestError(error);
        }
    }
}

export default new TradeService();
